import { Color } from "../types";

export const brickWall = (color: Color) => ({
  backgroundColor: `${color}30`,
  backgroundImage: `linear-gradient(335deg, ${color} 23px, transparent 23px),
linear-gradient(155deg, ${color}60 23px, transparent 23px),
linear-gradient(335deg, ${color} 23px, transparent 23px),
linear-gradient(155deg, ${color}60 23px, transparent 23px)`,
  backgroundSize: "58px 58px",
  backgroundPosition: "0px 2px, 4px 35px, 29px 31px, 34px 6px",
});
